var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScoreRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 54,
    viewBox: "0 0 38 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.968,
    y: 7.27289,
    width: 3.34286,
    height: 11.7615,
    rx: 1.67143,
    transform: "rotate(61.0951 23.968 7.27289)",
    fill: "#FB7B55"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.25806,
    y: 0.697571,
    width: 3.34286,
    height: 7.07926,
    rx: 1.67143,
    transform: "rotate(24.5258 8.25806 0.697571)",
    fill: "#1D3C8A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2637,
    y: 24.0759,
    width: 3.34286,
    height: 18.0445,
    rx: 1.67143,
    transform: "rotate(99.9939 35.2637 24.0759)",
    fill: "#3FA2F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.571,
    y: 40.4583,
    width: 3.34286,
    height: 11.2949,
    rx: 1.67143,
    transform: "rotate(127.874 25.571 40.4583)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.531,
    y: 49.2481,
    width: 3.34286,
    height: 9.34244,
    rx: 1.67143,
    transform: "rotate(151.626 13.531 49.2481)",
    fill: "#6CE2E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreRight);
export default __webpack_public_path__ + "static/media/score-right.f8b762b8e5de24ee5d6b028a7b02b51b.svg";
export { ForwardRef as ReactComponent };